<template>
  <div class="tab-panel athletics">
    <div class="sports">
      <ul>
        <li v-for="(item, index) in sports" :key="index" @click="gotoAthletics( Math.pow(2, index))">
          <img :src="require(`@/assets/image/news/athletics_icon_${index}.png`)" alt="" />
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <!-- 器材 -->
    <div class="equipment box-con">
      <div class="title">
        <el-col :span="12">
          <i></i>
          <h3>器材科普</h3>
        </el-col>
        <el-col :span="12">
          <span @click="gotoMore('categorys', '器材科普')"
            >查看更多<em class="el-icon-arrow-right"></em
          ></span>
        </el-col>
      </div>
      <!-- pc端 -->
      <div class="content" v-if="equipment.length">
        <div class="left" @click="gotoNewsDetail(equipment[0].id)">
          <img
            :src="equipment[0].img"
            alt=""
          />
          <div class="bg">
            <div>
              <p class="bg-title">{{ equipment[0].title }}</p>
              <p class="bg-time">{{ equipment[0].createdate ? moment(equipment[0].createdate).format('YYYY-MM-DD') : '' }}</p>
            </div>
          </div>
        </div>
        <div class="center">
          <div v-for="(item, index) in equipment.slice(1, 3)" :key="index" @click="gotoNewsDetail(item.id)">
            <img
              :src="item.img"
              alt=""
            />
            <div class="bg">
              <div>
                <p class="bg-title">{{ item.title }}</p>
                <p class="bg-time">{{ item.createdate ? moment(item.createdate).format('YYYY-MM-DD') : '' }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <ul>
            <li v-for="(item, index) in equipment.slice(3, 6)" :key="index" @click="gotoNewsDetail(item.id)">
              <div class="right-left">
                <img :src="item.img" alt="" />
              </div>
              <div class="right">
                <h3>{{ item.title }}</h3>
                <p class="desc">{{ delHtmlTag(item.content) }}</p>
                <p class="date">{{ item.createdate ? moment(item.createdate).format('YYYY-MM-DD') : '' }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 移动端 -->
      <div class="equipment-content-mobile" v-if="equipment.length">
        <div class="left" @click="gotoNewsDetail(equipment[0].id)">
          <img
            :src="equipment[0].img"
            alt=""
          />
          <div class="bg">
            <div>
              <p class="bg-title">{{ equipment[0].title }}</p>
              <p class="bg-time">{{ equipment[0].createdate ? moment(equipment[0].createdate).format('YYYY-MM-DD') : '' }}</p>
            </div>
          </div>
        </div>
        <div class="right">
           <div v-for="(item, index) in equipment.slice(1, 3)" :key="index" @click="gotoNewsDetail(item.id)">
            <img
              :src="item.img"
              alt=""
            />
            <div class="bg">
              <div>
                <p class="bg-title">{{ item.title }}</p>
                <p class="bg-time">{{ item.createdate ? moment(item.createdate).format('YYYY-MM-DD') : '' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 场地 -->
    <div class="field box-con">
      <div class="title">
        <el-col :span="12">
          <i></i>
          <h3>场地科普</h3>
        </el-col>
        <el-col :span="12">
          <span @click="gotoMore('categorys', '场地科普')"
            >查看更多<em class="el-icon-arrow-right"></em
          ></span>
        </el-col>
      </div>
      <!-- pc端 -->
      <div class="content" v-if="playground.length">
        <ul>
          <li
            v-for="(item, index) in playground"
            :key="index"
            @click="gotoNewsDetail(item.id)"
          >
            <div class="top">
              <img :src="item.img" alt="" />
            </div>
            <div class="bottom">
              <p class="date">{{ moment(item.createdate).format('YYYY-MM-DD') }}</p>
              <h3>{{ item.title }}</h3>
              <p class="desc">{{ delHtmlTag(item.content) }}</p>
            </div>
          </li>
          <i></i><i></i>
        </ul>
      </div>
      <!-- 移动端 -->
      <div class="field-content-mobile" v-if="playground.length">
        <ul>
          <li v-for="(item, index) in playground" :key="index" @click="gotoNewsDetail(item.id)">
            <div class="left">
              <h3>{{ item.title }}</h3>
              <p>{{ delHtmlTag(item.content) }}</p>
            </div>
            <div class="right">
              <img :src="item.img" alt="" />
              <p class="time">{{ moment(item.createdate).format('YYYY-MM-DD') }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 相关书籍 -->
    <div class="books box-con">
      <div class="title">
        <el-col :span="12">
          <i></i>
          <h3>相关书籍</h3>
        </el-col>
        <el-col :span="12">
          <router-link to="/service/books?id=8" class="more-link"
            >查看更多<em class="el-icon-arrow-right"></em
          ></router-link>
        </el-col>
      </div>
      <!-- pc端 -->
      <div class="content">
        <ul>
          <li
            v-for="(item, index) in bookList"
            :key="index"
            @click="gotoBookDetail(item.id)"
          >
            <div class="top">
              <img :src="item.coverimg" alt="" />
            </div>
            <div class="bottom">
              <p class="date">{{ item.author }}</p>
              <h3>{{ item.name }}</h3>
              <p class="desc">{{ delHtmlTag(item.bookIntroduction) }}</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 移动端 -->
      <div class="books-content-mobile">
        <ul>
          <li v-for="(item, index) in bookList" :key="index">
            <div class="left">
              <img :src="item.coverimg" />
            </div>
            <div class="right">
              <p class="txt">
                {{ item.name }}
              </p>
              <p class="author">
                {{ item.author }}
              </p>
              <p class="desc">
                {{ delHtmlTag(item.bookIntroduction) }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import book from '@/api/book';
import { getNewsList } from "@/api/news.js";
import { delHtmlTag } from "@/utils/index.js";
import moment from "moment";
export default {
  data() {
    return {
      sports: [
        {
          id: 1,
          name: "短距离跑",
        },
        {
          id: 2,
          name: "接力跑",
        },
        {
          id: 3,
          name: "中长跑",
        },
        {
          id: 4,
          name: "3000米障碍跑",
        },
        {
          id: 5,
          name: "竞走",
        },
        {
          id: 6,
          name: "跨栏",
        },
        {
          id: 7,
          name: "跳远",
        },
        {
          id: 8,
          name: "三级跳远",
        },
        {
          id: 9,
          name: "马拉松",
        },
        {
          id: 10,
          name: "跳高",
        },
        {
          id: 11,
          name: "撑竿跳高",
        },
        {
          id: 12,
          name: "铁饼",
        },
        {
          id: 13,
          name: "铅球",
        },
        {
          id: 14,
          name: "链球",
        },
        {
          id: 15,
          name: "标枪",
        },
      ],
      equipment: [],
      playground: [],
      bookList: []
    };
  },
  methods: {
    delHtmlTag,
    moment,
    gotoAthletics(value){
      getNewsList({athletics:value}).then(res=>{
        console.log(res.data);
        if(res.data.list && res.data.list.length){
           this.$router.push(`/news/newsDetail?id=${ res.data.list[0].id}`);
        }
       
      });
       
    },
    gotoBookDetail(id) {
      this.$router.push(`/service/article-detail?id=8&artId=${id}`);
    },
    gotoNewsDetail(id) {
      this.$router.push(`/news/newsDetail?id=${id}`);
    },
    gotoMore(type, val) {
      this.$router.push(`/more?type=${type}&val=${val}`);
    },
    getList(){
        getNewsList({
          categorys: '器材科普',
          pageIndex: 1,
          pageSize: 6,
        }).then(res=>{
          this.equipment = res.data.list;
        });
        getNewsList({
          categorys: '场地科普',
          pageIndex: 1,
          pageSize: 3,
        }).then(res=>{
          this.playground = res.data.list;
        });
    },
    /***获取书籍列表*/
    getBookList(){
      book.list({
          pageSize: 3,
          pageIndex: 1
      }).then(res=>{
          this.bookList = res.data.list;
      });
    }
  },
  mounted(){ 
    this.getList();
    this.getBookList();
  }
};
</script>

<style lang="scss" scoped>
.tab-panel {
  width: 100%;
}
.more-link{
  text-decoration: none;
  color: #999;
}
@media screen and (min-width: 961px) {
  .athletics {
    .sports {
      ul {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 60px 0 30px 0px;
        box-sizing: border-box;
        li {
          display: flex;
          flex-direction: column;
          margin-bottom: 30px;
          width: 12.5%;
          box-sizing: border-box;
          justify-content: center;
          align-items: center;
          text-align: center;
          cursor: pointer;
          img {
            width: 72px;
            height: 72px;
            border-radius: 20px;
            margin-bottom: 10px;
          }
        }
        li:nth-child(8n + 1) {
          margin-left: 0%;
        }
      }
    }
  }
  .equipment {
    .content {
      margin: 32px 0 60px 0px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      height: 462px;
      img {
        border-radius: 8px;
        object-fit: cover;
      }
      div.left {
        width: 42.25%;
        position: relative;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
        }
        .bg {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          border-radius: 0px 0px 8px 8px;
          height: 182px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          div {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 114px 0px 0px 24px;
          }
          .bg-title {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bg-time {
            margin-top: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            line-height: 14px;
          }
        }
      }
      div.center {
        width: 22.75%;
        height: 100%;
        margin-right: 40px;
        div {
          width: 100%;
          height: 221px;
          position: relative;
          &:nth-child(1) {
            margin-bottom: 20px;
          }
          .bg {
            border-radius: 0px 0px 8px 8px;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 87px;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              #000000 100%
            );
            div {
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              padding: 24px 0px 0px 24px;
            }
            .bg-title {
              font-size: 18px;
              font-weight: 400;
              color: #ffffff;
              line-height: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .bg-time {
              margin-top: 12px;
              font-size: 14px;
              font-weight: 400;
              color: #ffffff;
              line-height: 14px;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      div.right {
        width: 30%;
        ul li {
          height: 164px;
          display: flex;
          flex-direction: row;
          box-sizing: border-box;
          padding: 30px 0px;
          border-bottom: 1px solid rgba(216, 216, 216, 0.43);
          &:nth-child(1) {
            padding-top: 0px;
            height: 134px;
          }
          .right-left{
            width: 133px;
          }
          img {
            width: 100%;
            height: 103px;
            vertical-align: middle;
          }
          div.right {
            flex: 1;
            padding-left: 10px;
            box-sizing: border-box;
            h3 {
              font-weight: normal;
              color: #222;
              font-size: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: 400;
            }
            p {
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              color: #666;
              font-weight: 400;
              margin-top: 12px;
            }
            p.date {
              font-size: 14px;
              font-weight: 400;
              color: #b2b2b2;
            }
          }
        }
      }
    }
  }
  .box-con {
    .title {
      height: 30px;
      line-height: 30px;
      .el-col {
        display: flex;
        flex-direction: row;
        align-items: center;
        i {
          width: 4px;
          height: 28px;
          background-color: #da5351;
          margin-right: 10px;
        }
        h3 {
          font-size: 28px;
          font-weight: 400;
          color: #222222;
        }
      }
      span, .more-link {
        width: 100%;
        display: flex;
        justify-content: end;
        color: #e4e4e4;
        font-size: 20px;
        font-weight: 400;
        color: #999999;
        align-items: center;
        cursor: pointer;
        em {
          width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 14px;
          text-align: center;
          background-color: #e4e4e4;
          border-radius: 50%;
          margin-left: 8px;
        }
      }
    }
  }
  .equipment-content-mobile,
  .books-content-mobile {
    display: none;
  }
  .field,
  .books {
    .content {
      height: auto;
      margin: 32px 0px 60px 0px;
      ul {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        i{
          width: calc((100% - 60px) / 3);
        }
        li {
          width: calc((100% - 60px) / 3);
          display: flex;
          flex-direction: column;
          align-items: stretch;
          img {
            width: 100%;
            height: 206px;
            object-fit: cover;
            vertical-align: middle;
          }
          .bottom {
            padding: 16px 20px 16px 20px;
            box-sizing: border-box;
            background-color: #fafafa;
            font-size: 14px;
            opacity: 0.73;
            border: 1px solid #e6e6e6;
            flex: 1;
          }
          p.date {
            box-sizing: border-box;
            padding: 16px 0px;
            color: #b2b2b2;
            border-bottom: 1px dotted #dddddd;
          }
          h3 {
            padding: 16px 0px;
            font-size: 18px;
            height: 18px;
            color: #222;
            white-space: nowrap;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            overflow: hidden;
            -webkit-box-orient: vertical;
          }
          p.desc {
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }
      }
    }
    .field-content-mobile {
      display: none;
    }
  }
}
@media screen and (max-width: 960px) {
  .athletics {
    .sports {
      ul {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 0.16rem 0 0 0;
        box-sizing: border-box;
        li {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          margin-bottom: 0.16rem;
          width: 20%;
          box-sizing: border-box;
          justify-content: center;
          text-align: center;
          font-size: 0.12rem;
          font-weight: 400;
          color: #454545;
          img {
            width: 0.44rem;
            height: 0.44rem;
            border-radius: 0.14rem;
            margin-bottom: 0.2rem;
            align-self: center;
            // margin: 0 auto;
          }
          span {
            white-space: nowrap;
          }
        }
      }
    }
  }
  .box-con {
    padding-bottom: 0.24rem;
    .title {
      height: 0.24rem;
      margin-bottom: 0.12rem;
      line-height: 0.24rem;
      .el-col {
        display: flex;
        flex-direction: row;
        i {
          display: none;
        }
        h3 {
          font-size: 0.18rem;
          font-weight: 500;
          color: #333333;
        }
        span, .more-link {
          width: 100%;
          display: flex;
          justify-content: end;
          font-size: 0.14rem;
          font-weight: 400;
          color: #999999;
          align-items: center;
          cursor: pointer;
          em {
            width: 0.14rem;
            height: 0.14rem;
            line-height: 0.14rem;
            font-size: 0.08rem;
            text-align: center;
            background-color: #e4e4e4;
            border-radius: 50%;
            margin-left: 0.08rem;
          }
        }
      }
      .txt-right {
        display: none;
      }

      span {
        display: none;
      }
    }
    .content {
      display: none;
    }
  }
  .equipment-content-mobile {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    height: 1.8rem;
    justify-content: space-between;
    div.left {
      width: 50%;
      margin-right: 0.04rem;
      box-sizing: border-box;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .bg {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0.71rem;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
        div {
          position: absolute;
          left: 8px;
          bottom: 8px;
        }
        .bg-title {
          font-size: 0.14rem;
          font-weight: 400;
          color: #ffffff;
          line-height: 0.18rem;
        }
        .bg-time {
          margin-top: 0.08rem;
          font-size: 0.12rem;
          font-weight: 400;
          color: #ffffff;
          line-height: 0.14rem;
        }
      }
    }
    div.right {
      width: 50%;
      margin-left: 0.04rem;
      box-sizing: border-box;
      div {
        img {
          width: 100%;
          height: 100%;
        }
        width: 100%;
        height: 48%;
        position: relative;
        &:nth-child(1) {
          margin-bottom: 0.08rem;
        }
        .bg {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 0.34rem;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
          line-height: 0.34rem;
          p {
            margin: 0 0 0 0.08rem;
            font-size: 0.12rem;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
  .field,
  .books {
    .content {
      display: none;
    }
    .field-content-mobile li {
      height: 1.12rem;
      width: 100%;
      color: #666666;
      padding: 0.1rem 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      border-top: 1px solid #f1f1f1;
      display: flex;
      justify-content: space-between;
      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        img {
          width: 1.2rem;
          height: 0.68rem;
          border-radius: 0.04rem;
        }
        .time {
          font-size: 0.12rem;
          font-weight: 400;
          color: #666666;
          line-height: 0.14rem;
          text-align: right;
          margin-top: 0.1rem;
        }
      }
      .left {
        flex: 1;
        max-width: 2.1rem;
        h3 {
          font-size: 0.14rem;
          font-weight: 500;
          color: #454545;
          line-height: 0.22rem;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: keep-all;
          white-space: nowrap;
        }
        p {
          font-size: 0.12rem;
          font-weight: 400;
          color: #999999;
          line-height: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }
    }
    .books-content-mobile li {
      height: 1.12rem;
      width: 100%;
      color: #666666;
      padding: 0.12rem 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      border-top: 1px solid #f1f1f1;
      align-items: center;
      display: flex;
      .left {
        width: 0.7rem;
        height: 0.94rem;
        margin-right: 0.16rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: 0.04rem;
        }
      }
      .right {
        flex: 1;
        .txt {
          font-size: 0.14rem;
          font-weight: 400;
          color: #222222;
          line-height: 0.18rem;
          margin-bottom: 0.1rem;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          overflow: hidden;
          -webkit-box-orient: vertical;
        }
        .author {
          font-size: 0.12rem;
          font-weight: 400;
          color: #454545;
          line-height: 0.14rem;
          margin-bottom: 0.08rem;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          overflow: hidden;
          -webkit-box-orient: vertical;
        }
        .desc {
          font-size: 0.12rem;
          font-weight: 400;
          color: #666666;
          line-height: 0.22rem;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          overflow: hidden;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>